module.exports = __webpack_public_path__ + "img/freespin1_multiplier2.077d61d7.png";